import { type IAsyncSelectWidget } from '../../IAsyncSelectWidget.ts';
import { getLabelFields } from './getLabelFields.ts';

/**
 * Funzione del widget di scelta da servizio esterno che calcola
 * la label del valore selezionato.
 *
 * Al momento è la concatenzazione dei valori configurati separati da "-".
 */
export function getSelectedValueLabel(
  widget: IAsyncSelectWidget,
  values: Record<string, any> | undefined,
) {
  if (!values) return '';
  const labelFields = getLabelFields(widget);

  return getAsyncServiceLabel(labelFields, values);
}

export function getAsyncServiceLabel(
  labelFields: string[],
  values: Record<string, any> | undefined,
) {
  if (!values) return '';
  const labelValues = labelFields.map(field => values[field]).filter(Boolean);

  return labelValues.join(' - ');
}
